import { capitalizeText } from 'src/util/formatters/stringNormalizer';
import { wrapString } from '../../../../../util/formatters/wrap';
import { toEchartData } from './dataProcessor';

function getOption(echartData, theme, chartFontSize, disabledLegends = [], highlitIndex) {
  const { legends, categories, series } = echartData;

  // Persistencia de estado das legendas
  const selectedLegends = {};
  legends.forEach((legend) => {
    selectedLegends[legend] = !disabledLegends.includes(legend);
  });

  /**
   * apenas uma proporção comum (sem considerar resolução)
   * considerando uma resolução 1366x768 foi visto que,
   * no grafico com 5 barras, cada uma podia ter até 10 caracteres,
   * então fazemos uma proporção com base na quantidade de barras a ser renderizada.
   * Calculamos o maior length permitido para que o texto seja quebrado em linhas
   * e desta forma, caiba dentro de cada barra.
   */
  const randomBarsNum = 5;
  const lengthThatFitsEachBar = 11;
  const factor = randomBarsNum * lengthThatFitsEachBar;
  const length = Math.round(factor / categories.length);

  const formattedCategories = categories.map((category) => wrapString(category, length, 5, length < 10));

  const tooltipFormatter = (stackItens) => {
    const first = stackItens[0];
    const output = stackItens
      .map((item) => `${item.marker} ${item.seriesName}: ${item.data.numeric} (${item.data.value}%)`)
      .reverse()
      .reduce((reduced, next) => reduced.concat('<br>').concat(next));

    const title = categories[first.dataIndex];
    return `${title}<br>${output}`;
  };

  return {
    animationDuration: 0,
    color: theme.colors,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: tooltipFormatter,
      confine: true,
    },
    visibleLegends: legends,
    legend: {
      selected: selectedLegends,
      type: 'scroll',
      data: legends,
      textStyle: {
        color: theme.legend.color,
        fontSize: chartFontSize,
        fontFamily: 'Roboto, sans-serif',
      },
      formatter: capitalizeText,
      pageTextStyle: {
        color: theme.legend.pagination.text.color,
      },
      pageIconColor: theme.legend.pagination.buttons.color,
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: formattedCategories,
      axisLabel: {
        color: theme.axis.y.label,
      },
      axisLine: {
        lineStyle: {
          color: theme.axis.y.line,
        },
      },
      axisTick: {
        alignWithLabel: true,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: theme.axis.x.label,
      },
      axisLine: {
        lineStyle: {
          color: theme.axis.x.line,
        },
      },
    },
    series: series.reverse().map((item, index) => ({
      ...item,
      itemStyle: {
        ...(index === highlitIndex ? {
          borderType: theme.highlitedItemBorderType,
          borderColor: theme.highlitedItemBorderColor,
          borderWidth: theme.highlitedItemBorderWidth,
        } : {})
      },
    })),
  };
}

export default function toEchartOption(data, theme, chartFontSize, disabledLegends = [], highlitIndex) {
  const echartData = toEchartData(data, chartFontSize, theme, disabledLegends);
  return getOption(echartData, theme, chartFontSize, disabledLegends, highlitIndex);
}
